export const environment = {
    production: false,
    authorizationServiceUrl: 'https://us-central1-starkey-engage-develop.cloudfunctions.net',
    cloudCoreApiUrl: 'https://core-develop.telehearportal.com',
    //This key has to be exposed to show google maps so there's no point in grabbing it from secret manager
    googleMapsApiKey: 'AIzaSyD70bFGIRJ1Y3RpYd6up1V4dz5FNftb9hE',
    authDomain: 'engage-fall-management-develop.web.app',
    projectId: 'starkey-engage-develop'
  };  
